import axios from './Axios'

const nullSession = {userid:null, addressid: null, token:null, email: null, jwt: '', memberState: null, image: null, gender: null, birthday: null, name: null};
const nullBucket = {};
const crnt = {
    session: global.localStorage?JSON.parse(localStorage.getItem('session') || '{}'):nullSession,
    bucket: global.localStorage?JSON.parse(localStorage.getItem('bucket') || '{}'):nullBucket,
    isManager: global.localStorage?JSON.parse(localStorage.getItem('isManager') || 'false'):false,
};

const sessionRefresh = async () => {
    const session = crnt.session;
    
    try{
        let res = await axios.post(
            '/session', 
            (session.userid && session.token)?{userid: session.userid, token: session.token}:{}
        );
        
        if (res.data.code === 200 && res.data.data && res.data.data.userid){
            if (!res.data.data.image){
                res.data.data.image = "https://static.koreanmate.app/noimage.jpg";
            }
            crnt.session = res.data.data;
            localStorage.setItem('session', JSON.stringify(crnt.session));
        } else {
            crnt.session = nullSession;
            localStorage.removeItem('session');
        }
    }catch(e){
        crnt.session = nullSession;
        localStorage.removeItem('session');
    } finally{
        return crnt.session;
    }
}       

const EmailSignupWithOtp = async (email:string, otp:string, name: string, userid?: string) => {
    if ('gtag' in window){
        (window as any).gtag('event', 'sign_up', {'method': userid ? 'userid_otp' : 'email_otp'});
    }
    
    // Either email or userid must be provided
    if (email || userid){
        try{
            // Verify OTP using the session/otp endpoint
            let res = await axios.put(
                '/session/otp',
                {
                    otp,
                    ...(email ? { email } : {}),
                    ...(userid ? { userid } : {}),
                    ...(name ? { name } : {})
                }
            );

            if (res.data.code === 200 && res.data.data && res.data.data.userid){
                if (!res.data.data.image){
                    res.data.data.image = "https://static.koreanmate.app/noimage.jpg";
                }
                crnt.session = res.data.data;
                localStorage.setItem('session', JSON.stringify(crnt.session));
            }else{
                crnt.session = nullSession;
                localStorage.removeItem('session');
            }
        }catch(e){
            console.error(e);
            crnt.session = nullSession;
            localStorage.removeItem('session');
        } finally{
            return crnt.session;
        }
    }
    return crnt.session;
}

const GoogleSignin = async (response: {code: string|number}, ) => {
    if ('gtag' in window){
        (window as any).gtag('event', 'login_attempt', {'method': 'google'});
    };

    if (response.code){
        try{
            let res = await axios.put(
                '/session',
                {gsso: response}
            );
            
            if (res.data.code === 200 && res.data.data && res.data.data.userid){
                if (!res.data.data.image){
                    res.data.data.image = "https://static.koreanmate.app/noimage.jpg";
                }
                crnt.session = res.data.data;
                localStorage.setItem('session', JSON.stringify(crnt.session));
            }else{
                crnt.session = nullSession;
                localStorage.removeItem('session');
            }
        }catch(e){
            console.error(e);
        } finally{
            return crnt.session;
        }
    }
    return crnt.session;
}

const AppleSignin = async (response: {id_token: string}, ) => {
    if ('gtag' in window){
        (window as any).gtag('event', 'login_attempt', {'method': 'apple'});
    }
    if (response.id_token){
        try{
            let res = await axios.put(
                '/session',
                {asso: response}
            );

            if (res.data.code === 200 && res.data.data && res.data.data.userid){
                if (!res.data.data.image){
                    res.data.data.image = "https://static.koreanmate.app/noimage.jpg";
                }
                crnt.session = res.data.data;
                localStorage.setItem('session', JSON.stringify(crnt.session));
            }else{
                crnt.session = nullSession;
                localStorage.removeItem('session');
            }
        }catch(e){
            console.error(e);
        } finally{
            return crnt.session;
        }
    }
    return crnt.session;
}

const logout = async () => {
    crnt.session = nullSession;
    localStorage.removeItem('session');
    return crnt.session;
}

const isManager = async () => {
    if (crnt.isManager){
        return crnt.isManager;
    }
    try{
        let res = await axios.get(`/user/is-manager`,{
            headers: {
                Authorization: `Bearer ${crnt.session.jwt}`
            },
            withCredentials: true
        })
        
        if (res.data && res.data.code === 200){
            crnt.isManager = res.data.data;
            localStorage.setItem('isManager', JSON.stringify(crnt.isManager));
            return res.data.data.data;
        } else {
            crnt.isManager = false;
            localStorage.setItem('isManager', JSON.stringify(crnt.isManager));
            return false;
        }

    } catch(e) {
        crnt.isManager = false;
        localStorage.setItem('isManager', JSON.stringify(crnt.isManager));
        return false;
    }
}

// Function to request an OTP code
const requestOtp = async (params: {email?: string; userid?: string; notice_by?: string; purpose?: string}) => {
    const { email, userid, notice_by = 'email', purpose = 'authentication' } = params;
    
    if (!email && !userid) {
        console.error('Either email or userid must be provided to request OTP');
        return { code: 400, message: 'Either email or userid is required' };
    }
    
    try {
        const res = await axios.post('/session/otp', {
            notice_by,
            purpose,
            ...(email ? { email } : {}),
            ...(userid ? { userid } : {})
        });
        
        if (res.data.code === 200) {
            // If notice_by is 'response', the OTP is returned directly for testing
            if (notice_by === 'response' && res.data.data.otp) {
                return { 
                    code: 200, 
                    message: 'OTP generated successfully',
                    otp: res.data.data.otp 
                };
            }
            
            return { 
                code: 200, 
                message: 'OTP sent successfully' 
            };
        } else {
            return res.data;
        }
    } catch (e) {
        console.error('Error requesting OTP:', e);
        return { 
            code: 500, 
            message: 'Failed to request OTP' 
        };
    }
};

// Cross-device authorization functions
const createAuthRequest = async () => {
    try {
        const res = await axios.post('/session/request');
        
        if (res.data.code === 200) {
            return res.data.data;
        } else {
            return { error: res.data.message || 'Failed to create authorization request' };
        }
    } catch (e) {
        console.error('Error creating auth request:', e);
        return { error: 'Failed to create authorization request' };
    }
};


const pollAuthStatus = async (pincode: string) => {
    try {
        const res = await axios.get(`/session/request?pincode=${pincode}`);
        
        if (res.data.code === 200) {
            // Authorization successful, update session
            if (res.data.data && res.data.data.userid) {
                if (!res.data.data.image) {
                    res.data.data.image = "https://static.koreanmate.app/noimage.jpg";
                }
                crnt.session = res.data.data;
                localStorage.setItem('session', JSON.stringify(crnt.session));
                return { success: true, session: res.data.data };
            }
        } else if (res.data.code === 202) {
            // Still pending
            return { pending: true, context: res.data.data };
        } else if (res.data.code === 404) {
            // Expired or invalid
            return { error: 'PIN code expired or invalid' };
        }
        
        return { error: res.data.message || 'Unknown error' };
    } catch (e) {
        console.error('Error polling auth status:', e);
        return { error: 'Failed to check authorization status' };
    }
};

const sessionFuncs = {
    GoogleSignin,
    AppleSignin,
    sessionRefresh,
    EmailSignupWithOtp,
    requestOtp,
    createAuthRequest,
    pollAuthStatus,
    isManager,
    logout,
    getCurrentSession: () => {return crnt.session},
};

export default sessionFuncs;